import { render, staticRenderFns } from "./BanciUpdate.vue?vue&type=template&id=b89992ea&scoped=true&"
import script from "./BanciUpdate.vue?vue&type=script&lang=js&"
export * from "./BanciUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BanciUpdate.vue?vue&type=style&index=0&id=b89992ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89992ea",
  null
  
)

export default component.exports